import { useState } from 'react'
import { 
  Box,
  Container,
  Divider,
} from '@mui/material'

import Loading from './loading'
import AccountSettings from '../components/account/settings'
import AccountImage from '../components/account/image'
import AccountUser from '../components/account/user'
import AccountLogout from '../components/account/logout'
import AccountStatsLink from '../components/account/stats-link'

export default function Account() {
  const [loading, setLoading] = useState(false)

  if (loading) return <Loading/>

  return (
    <Container maxWidth="xs" sx={{ position: 'relative' }}>
      <AccountLogout onSignout={() => setLoading(true)} />
      <AccountImage />
      <AccountUser />
      <Divider />
      <AccountStatsLink />
      <Divider />
      <AccountSettings />
      <Box sx={{ height: 64 }} />
    </Container>
  )
}
